import { ComponentEmbeddedFragment } from "contentful/gql/graphql";
import { cn } from "utils/functions";

interface EmbeddedProps {
  embedded: ComponentEmbeddedFragment;
  className?: string;
}

export default function Embedded({ embedded, className }: EmbeddedProps) {
  return (
    <div className={cn("relative w-full", className)}>
      <div className="relative w-full pb-[56.25%]">
        <iframe
          src={embedded.iframeUrl || ""}
          className="absolute left-0 top-0 h-full w-full rounded-lg"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Embedded content"
        />
      </div>
    </div>
  );
}
